// taken from server - https://github.com/wix-private/wix-answers-server/blob/fd31c57105fc664e071b154239d0d929e36641fd/answers/wix-answers-core/src/main/java/com/wixpress/answers/common/exceptions/Errors.java#L27
export var getErrorForBi = function (errorCode) {
    switch (errorCode) {
        // general errors
        case -1:
            return "UNKNOWN";
        case -10:
            return "GENERAL";
        case -50001:
            return "FORBIDDEN";
        case -50002:
            return "RUNTIME";
        case -50004:
            return "VALIDATION";
        case -50005:
            return "UNAUTHORIZED";
        case -50006:
            return "NOT_FOUND";
        case -50007:
            return "MOVED";
        case -50008:
            return "DUPLICATION";
        case -50009:
            return "THROTTLED";
        // users errors
        case 401:
            return "UNAUTHORIZED";
        case -52005:
            return "EMAIL_NOT_VERIFIED";
        case -52006:
            return "PASSWORD_NOT_SET";
        case -52007:
            return "SOCIAL_EMAIL_NOT_VERIFIED";
        case -52008:
            return "EMAIL_ALREADY_VERIFIED";
        case -52009:
            return "EMAIL_NOT_CHANGED";
        case -52010:
            return "USER_NOT_UNAUTHENTICATED";
        case -52011:
            return "INVALID_PASSWORD";
        case -52012:
            return "INVALID_EMAIL";
        case -52013:
            return "PRIVACY_NON_COMPLIANT_USER";
        case -52014:
            return "INVALID_TOKEN";
        case -52015:
            return "INVALID_API_KEY";
        case -52016:
            return "INVALID_PHONE_NUMBER";
        case -63003:
            return "INVALID_AUTH_TYPE";
        case -63004:
            return "SSO_DISABLED";
        case -63005:
            return "SSO_ENABLED";
        case -63006:
            return "INVALID_USER_TYPE";
        // categories
        case -70001:
            return "NON_LEAF_CATEGORY";
        //files
        case -73001:
            return "FAILED_UPLOADING_ATTACHMENT";
        case -73002:
            return "INVALID_EXTENSION";
        case -73003:
            return "MAX_FILE_SIZE_EXCEEDED";
        case -110002:
            return "WAITING_CALLBACK_EXISTS";
        case -110003:
            return "CALLBACK_DISABLED";
        case -120000:
            return "PHONE_NUMBER_REQUIRES_ADDRESS";
        case -120001:
            return "PHONE_NUMBER_REQUIRES_LOCAL_ADDRESS";
        case -120002:
            return "PHONE_NUMBER_REQUIRES_FOREIGN_ADDRESS";
        case -120003:
            return "ADDRESS_CANNOT_BE_VALIDATED";
        case -120004:
            return "IDENTITY_DOCUMENT_REQUIRED";
        case -130001:
            return "TRANSLATION_REQUEST_ERROR";
        case -130002:
            return "ATTEMPT_TO_DELETE_DEFAULT_QUEUE";
        case -130003:
            return "ATTEMPT_TO_DELETE_ASSIGNED_QUEUE";
        case -130004:
            return "ATTEMPT_TO_DELETE_QUEUE_WITH_CALLS";
        case -130005:
            return "ATTEMPT_TO_DELETE_IVR_WITH_CONNECTED_LINES";
        case -130006:
            return "INVALID_DOMAIN_CERTIFICATE";
        case -130007:
            return "CANNOT_CONNECT_DOMAIN";
        case -130008:
            return "PREMIUM_FEATURES_VIOLATION";
        case -140001:
            return "INVALID_CONTENT";
        // tickets
        case -150000:
            return "TICKET_CCS_LIMIT_REACHED";
        default:
            return "Unknown error - " + errorCode;
    }
};
//# sourceMappingURL=error-types.js.map